import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { CV } from '../../../shared/models/cv/cv';
import { WorkShop } from '../../../shared/models/cv/work-shop';

@Component({
  selector: 'app-cv-view-workshops',
  templateUrl: './cv-view-workshops.component.html',
  styleUrls: ['./cv-view-workshops.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CvViewWorkshopsComponent implements OnInit {
  @Input() cv: CV;
  constructor() { }

  ngOnInit() { }

  get workshops(): WorkShop[] {
    const workshops = this.cv ? this.cv.experience.workshops : null;
    return workshops && workshops.length > 0
      ? workshops.sort((a, b) =>
        this.getTimeSortNumber(a.date, b.date)
      )
      : null;
  }

  private getTimeSortNumber(dateA: Date, dateB: Date): number {
    const aTime = dateA ? dateA.getTime() : Infinity;
    const bTime = dateB ? dateB.getTime() : Infinity;
    return bTime - aTime;
  }

  trackByFn(index, item) {
    return (item.key || item.id || item.uid);
  }
}
